import React from 'react';
import { Dialog } from '@headlessui/react';

type Props = {
  title?: string;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
};

function ModalHeader({ children, title, subtitle }: Props) {
  if (children && title) {
    throw Error('Specify either title or children!');
  }

  // Modal points aria-labelledby at this id, so a header is what names the dialog.
  if (title) {
    return (
      <div className="modal-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6">
        <div className="leading-6" id="modal-headline">
          {title}
        </div>
        <div className="mt-1 text-sm font-normal text-gray-500">{subtitle}</div>
      </div>
    );
  }

  return (
    <div
      className="modal-header border-b border-gray-200 px-4 py-5 font-medium text-gray-900 sm:px-6"
      id="modal-headline"
    >
      {children}
    </div>
  );
}

export default ModalHeader;
